// Build responsive article navigation from authored H2 headings.
(function () {
    var navigation = document.querySelector('[data-article-toc]');
    var rail = document.querySelector('[data-editorial-rail]');
    var content = document.querySelector('[data-article-content]');

    if (!navigation || !rail || !content) {
        return;
    }

    var headings = Array.from(content.querySelectorAll(':scope > h2[id]'));

    if (headings.length < 2) {
        return;
    }

    var tocList = navigation.querySelector('[data-article-toc-list]');
    var railList = rail.querySelector('[data-editorial-rail-list]');
    var progressBar = rail.querySelector('[data-editorial-rail-progress-bar]');
    var progressText = rail.querySelector('[data-editorial-rail-progress-text]');
    var tocLinks = [];
    var railLinks = [];
    var currentHeading = null;
    var visualMedia = Array.from(content.children).filter(function (element) {
        return element.matches(':is(.kg-image-card, .kg-gallery-card, .kg-video-card, .kg-embed-card):is(.kg-width-wide, .kg-width-full)');
    });
    var desktopRail = window.matchMedia('(min-width: 1180px)');

    function appendLink(list, heading, links) {
        var item = document.createElement('li');
        var link = document.createElement('a');

        link.href = '#' + heading.id;
        link.textContent = heading.textContent;
        item.appendChild(link);
        list.appendChild(item);
        links.push(link);
    }

    headings.forEach(function (heading) {
        appendLink(tocList, heading, tocLinks);
        appendLink(railList, heading, railLinks);
    });

    navigation.hidden = false;
    rail.hidden = false;
    document.documentElement.classList.add('has-editorial-rail');

    function setActive(activeHeading) {
        if (activeHeading === currentHeading) {
            return;
        }

        currentHeading = activeHeading;
        var activeIndex = headings.indexOf(activeHeading);

        [tocLinks, railLinks].forEach(function (links) {
            links.forEach(function (link, index) {
                if (index === activeIndex) {
                    link.setAttribute('aria-current', 'location');
                } else {
                    link.removeAttribute('aria-current');
                }
            });
        });
    }

    setActive(headings[0]);

    var ticking = false;

    function updateRailVisibility() {
        var overlapsVisual = false;

        if (desktopRail.matches && visualMedia.length) {
            var railRect = rail.querySelector('.editorial-rail-inner').getBoundingClientRect();

            overlapsVisual = visualMedia.some(function (media) {
                var mediaRect = media.getBoundingClientRect();

                return mediaRect.bottom > railRect.top &&
                    mediaRect.top < railRect.bottom &&
                    mediaRect.right > railRect.left &&
                    mediaRect.left < railRect.right;
            });
        }

        rail.classList.toggle('is-over-visual', overlapsVisual);
        rail.inert = overlapsVisual;

        if (overlapsVisual) {
            rail.setAttribute('aria-hidden', 'true');
        } else {
            rail.removeAttribute('aria-hidden');
        }
    }

    function updateProgress() {
        var rect = content.getBoundingClientRect();
        var startLine = window.innerHeight * 0.3;
        var readableDistance = Math.max(rect.height - window.innerHeight * 0.4, 1);
        var progress = Math.min(Math.max((startLine - rect.top) / readableDistance, 0), 1);
        var percentage = Math.round(progress * 100);
        var activeHeading = headings[0];

        headings.forEach(function (heading) {
            if (heading.getBoundingClientRect().top <= startLine) {
                activeHeading = heading;
            }
        });

        setActive(activeHeading);
        updateRailVisibility();
        progressBar.style.transform = 'scaleX(' + progress + ')';
        progressText.textContent = percentage + '%';
        ticking = false;
    }

    function requestProgressUpdate() {
        if (!ticking) {
            window.requestAnimationFrame(updateProgress);
            ticking = true;
        }
    }

    window.addEventListener('scroll', requestProgressUpdate, {passive: true});
    window.addEventListener('resize', requestProgressUpdate);
    updateProgress();
})();
